import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
export default class ModuleLesson extends GenexLMSModel {
    static entity = 'moduleLesson'
    static primaryKey = ['module_id', 'lesson_id']
    static fields() {
        return {
            lesson_id: this.attr(null),
            module_id: this.attr(null),
            order: this.attr(null),
            completed:this.attr(null)
        }
    }

}
